var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('h1',[_vm._v("404 ERROR")]),_c('p',[_vm._v("Page not found")]),_c('vs-button',{attrs:{"href":"/#/"}},[_vm._v("Go back to Home Page")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }